export const CACHE_KEY_LIST_CLIENTS = 'clients';
export const CACHE_KEY_CLIENT = 'clients-one';
export const ROUTE_PATH_CLIENTS = '/clients';
export const TRANSLATION_PREFIX_CLIENTS = 'clients';

